import "./DataRoom.module.css";
import Header from "@/reusable_sections/Header";
import DataRoomIntro from "./sections/DataRoomIntro";
import RequestAccessForm from "./sections/RequestAccessForm";
import AvailableDocuments from "./sections/AvailableDocuments";
import Footer from "@/reusable_sections/Footer";
export default function DataRoomPage() {
  return <div>
      <Header />
      <DataRoomIntro />
      <RequestAccessForm />
      <AvailableDocuments />
      <Footer />
    </div>;
}